import React from 'react';
import { ConfirmDialog } from 'ui/dialogs/ConfirmDialog';

interface CampaignStopDialogProps {
    onClose: () => void;
    onAgree: () => void;
    open: boolean;
    loading?: boolean;
}

export const CampaignStopDialog: React.FC<CampaignStopDialogProps> = props => {
    const { onClose, open, onAgree, loading } = props;
    return (
        <ConfirmDialog
            title="Are you sure you wish to stop this Campaign?"
            content="Your Campaign will no longer be active!"
            open={open}
            onConfirm={onAgree}
            onCancel={onClose}
            loading={loading}
        />
    );
};
